// Filename: gani_graph.js
// Timestamp: 2018.01.15-23:42:21 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import {
  gngraphNodeRootGet as graphNodeRootGet,
  gngraphNodeSet as graphNodeSet,
  gngraphCreate as graphCreate
} from './gngraph.js'

import {
  gnnodeosChildSpecResolve,
  gnnodeosChildSetFromSpec as nodeosChildSetFromSpec,
  gnnodeosxVNodeGet,
  gnnodeosxGet as nodeosxGet,
  gnnodeosCreateInit as nodeosCreateInit,
  gnnodeosChildRm as nodeosChildRm,
  gnnodeosChildKeyMv as nodeosChildKeyMv,
  gnnodeosHydrateDFS,
  gnnodeosRootHydrateDFS
} from './gnnodeos.js'

import {
  gnreportCreate as reportCreate,
  gnreportMarkNodeTreeComplete as reportMarkNodeTreeComplete
} from './gnreport.js'

import {
  gnspec_pathseedanycreate
} from './gnspec.js'

import {
  gnenumKEY as KEY
} from './gnenum.js'

import {
  gnpathdef_pathpgarrget,
  gnpathdef_arrpermittedget,
  gnpathdef_prefixstrip
} from './gnpathdef.js'

// isfresh builds data AND render vnode
// !isfresh use existing data ONLY render vnode
const gnrenderHydrateVNode = async (ss, cfg, grspec, isfresh) => {
  const res = await gnnodeosRootHydrateDFS(ss, cfg, grspec, isfresh)
  const gr = res[0]
  const nd = res[1]
  const report = res[2]

  return [
    gr, nd,
    gnnodeosxVNodeGet(ss, cfg, gr, nd),
    reportMarkNodeTreeComplete(report, nd.get(KEY))]
}

// finpnodearr is path node object array
const gnrenderPath = async (ss, cfg, path) => {
  const reqpnodearr = gnpathdef_pathpgarrget(cfg,
    gnpathdef_prefixstrip(path, cfg.prefixdir))
  const finpnodearr = gnpathdef_arrpermittedget(ss, cfg, reqpnodearr)
  let ndroot, vtree, report, res, gr = graphCreate()

  // converts path nodes, to meta nodes organised in graph.
  const pathdirMetaArr = await gnspec_pathseedanycreate(ss, cfg, finpnodearr)
  res = graphNodeSet(
    gr, nodeosCreateInit(cfg, gr, pathdirMetaArr[0]))

  gr = res[0]

  res = await gnrenderHydrateVNode(ss, cfg, gr, true)
  gr = res[0]
  ndroot = res[1]
  vtree = res[2]
  report = res[3]

  return [gr, finpnodearr, pathdirMetaArr, ndroot, vtree, report]
}

// removed nodes correspoding to unique portion of prevstack
// call callback (allows callee to repopulate this state of graph
// construct and hydrate nodes corresponding to newstack
// move newnode positions the corresponding oldnode positions
// construct and return vnode from full graph
//
const gnrenderPathDiff = async (
  ss, cfg, gr, path, prevstackarr, onpartialfn, iscontinuefn
) => {
  const reqpnodearr = gnpathdef_pathpgarrget(cfg, path)
  const finpnodearr = gnpathdef_arrpermittedget(ss, cfg, reqpnodearr)
  const objarr = await gnspec_pathseedanycreate(ss, cfg, finpnodearr)
  let nd = graphNodeRootGet(gr), res, rootnode, vtree,
      report = reportCreate('diffpath')
  const ndpg = nodeosxGet(cfg, gr, nd)
  const rkey = `/${prevstackarr[1].name}`

  if (!iscontinuefn()) return null

  res = nodeosChildRm(ss, cfg, gr, nd, rkey)

  gr = res[0]
  nd = res[1]

  const cindex = res[3]
  const cdomindex = res[4]

  if (!iscontinuefn()) return null

  res = await onpartialfn(gr)

  gr = res[0]

  if (!iscontinuefn()) return null

  nd = gr.get(nd.get(KEY))

  res = await gnnodeosChildSpecResolve(ss, cfg, gr, nd, objarr[1], 0, (
    async (gr, nd, childspec/*, childnum*/) => {
      let child = null,
          res = nodeosChildSetFromSpec(
            ss, cfg, gr, nd, ndpg, childspec)
      gr = res[0]
      nd = res[1]
      child = res[2]
      // adding spec adds to end of child list.. so move to
      // position of previous child
      res = graphNodeSet(gr, nodeosChildKeyMv(nd, cindex, cdomindex))
      gr = res[0]
      nd = res[1]

      res = await gnnodeosHydrateDFS(ss, cfg, gr, child, report)

      return [res[0], res[1]] // eg, [gr, nd]
    })
  )

  gr = res[0]
  // return full vnode without reconstructing data
  res = await gnrenderHydrateVNode(ss, cfg, gr, false)
  gr = res[0]

  rootnode = res[1]
  vtree = res[2]
  report = res[3]

  if (!iscontinuefn()) return null

  return [gr, finpnodearr, objarr, rootnode, vtree, report]
}

export {
  gnrenderHydrateVNode,
  gnrenderPath,
  gnrenderPathDiff
}
